import VerticalLayout from "../../../../../lib/html5-software-library/src/ranj/components/layouts/VerticalLayout";
import Slice9Panel from "../../../../../lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import MCBlock from "../../../../../lib/html5-software-library/src/ranj/eng/content/MCBlock";
import TextContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/TextContent";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import SkinFactory from "../../../core/ui/SkinFactory";
import EmailInteractionEvent from "../controller/EmailInteractionEvent";
import EmailSoundType from "../sound/EmailSoundType";
import EmailConversationViewConstants from "./EmailConversationViewConstants";

export default class EmailDraftItemMediator extends AbstractMediator {
    constructor(target, dispatcher, languagePack, soundManager, emailModel, mediatorManager) {
        super(target, dispatcher);

        this._languagePack = languagePack;
        this._soundManager = soundManager;
        this._emailModel = emailModel;
        this._mediatorManager = mediatorManager;

        this._item = this.getCustomData().item;
        this._skinKeyRegistry = this.getCustomData().skinKeyRegistry;

        this._objectsToDestroy = [];
    }

    initialize() {
        super.initialize();

        this._blocksContainer = this._target.contentContainer;

        this.populate();
    }

    destroy() {
        this._item = null;

        this.cleanup();

        super.destroy();
    }

    cleanup() {
        this._blocksContainer.removeAllChildren();

        for (var i = 0; i < this._objectsToDestroy.length; i++) {
            this._objectsToDestroy[i].destroy();
        }

        this._objectsToDestroy = [];
    }

    populate() {
        const bitmap = this._target.children.find(c => c instanceof createjs.Bitmap);
        const slice9Panel = new Slice9Panel(this._target, bitmap);

        const verticalLayout = new VerticalLayout(this._blocksContainer, EmailConversationViewConstants.ITEM_SPACING);

        const contentBlocks = this._item.content.getContentBlocks();

        const numContentBlocks = contentBlocks.length;

        for (let i = 0; i < numContentBlocks; i++) {
            let contentBlock = contentBlocks[i];
            let blockView;
            switch (contentBlock.getType()) {
                case TextContent.TYPE:
                    blockView = this._createDraftTextComponent(contentBlock.getText() || "");
                    break;
                case MCBlock.TYPE:
                    blockView = this._createDraftInputComponent(contentBlock || "");
                    break;
            }

            verticalLayout.addItem(blockView);
        }

        const sendComponent = this._createSendComponent();
        verticalLayout.addItem(sendComponent);

        slice9Panel.update();
    }

    _createDraftTextComponent(text) {
        let skin = SkinFactory.getSkin(this._skinKeyRegistry.EMAIL_DRAFT_TEXT_COMPONENT_SKIN);
        skin.bodyTextField.text = text;

        return skin;
    }

    _createDraftInputComponent(mcBlock) {
        let skin;

        if (this._item.isSent) {
            skin = SkinFactory.getSkin(this._skinKeyRegistry.EMAIL_DRAFT_SENT_INPUT_COMPONENT_SKIN);
        } else {
            if (mcBlock.getSelectedOption() != null) {
                skin = SkinFactory.getSkin(this._skinKeyRegistry.EMAIL_DRAFT_INPUT_COMPONENT_SKIN);
            } else {
                skin = SkinFactory.getSkin(this._skinKeyRegistry.EMAIL_DRAFT_INPUT_SELECTION_COMPONENT_SKIN);
            }
        }

        skin.setBounds(skin.nominalBounds.x, skin.nominalBounds.y, skin.nominalBounds.width, skin.nominalBounds.height);

        skin.mcBlock = mcBlock;
        const mediator = this._mediatorManager.createMediator(skin, skin.skinType);
        this._objectsToDestroy.add(mediator);

        return skin;
    }

    _createSendComponent() {
        const skin = SkinFactory.getSkin(this._skinKeyRegistry.EMAIL_DRAFT_SEND_COMPONENT_SKIN);

        const mediator = this._mediatorManager.createMediator(skin, skin.skinType);
        this._objectsToDestroy.add(mediator);

        let button = this.createButton(skin.sentButton, this._handleSendClicked.bind(this), this._languagePack.getText(`email.sendDraftButtonLabel`), EmailSoundType.SWOOSH);
        button.setEnabled(this._item.isCompleted());
        button.setVisible(!this._item.isSent);
        this._objectsToDestroy.add(button);

        skin.setBounds(skin.nominalBounds.x, skin.nominalBounds.y, skin.nominalBounds.width, skin.nominalBounds.height);

        return skin;
    }

    _handleSendClicked() {
        this.dispatch(EmailInteractionEvent.SUBMIT_DRAFT, { item: this._item });
    }
}